import { Controller } from "@hotwired/stimulus"
import { fetchStream } from "../lib/stream_fetch"

// A row that arrived over a folder stream was rendered once for every
// member, so its folder cell has no placements (those are per viewer). On
// landing it fetches the viewer's own render of the row, which replaces it
// and carries no controller of its own (#3623).
export default class extends Controller {
  static values = { url: String }

  async connect() {
    this.abort = new AbortController()
    let response
    try {
    response = await fetchStream(this.urlValue, { signal: this.abort.signal })
    } catch (error) {
      if (error.name === "AbortError") return
      throw error
    }
    // A newer broadcast can replace this row while the request is in
    // flight; its answer must not overwrite the newer row.
    if (!this.element.isConnected || !response?.ok) return
    Turbo.renderStreamMessage(await response.text())
  }

  disconnect() {
    this.abort?.abort()
  }
}
